export enum AdCampaignStatus {
  active = 'ACTIVE',
  pending = 'PENDING',
  closed = 'CLOSED',
}

export enum AdCampaignItemMediaType {
  video = 'video',
  image = 'image',
  carousel = 'carousel',
}
